// TO SELECT MORE COMPLEX QUERIES, WHICH REQUIRE DATA PROCESSING
import { createSelector } from '@reduxjs/toolkit';

export const selectShiftsByAssignment = createSelector(
  [(state) => state.newShifts.shifts], // Only recalculated if `shifts` changes
  (shifts) => {
    const result = { unassigned: [], assigned: {} };

    for (const shift of shifts) {
      const { eid } = shift;

      if (eid) {
        // Shifts assigned by `eid`
        if (!result.assigned[eid]) {
          result.assigned[eid] = [];
        }
        result.assigned[eid].push(shift);
      } else {
        // Unassigned shifts: we store them in a single array
        result.unassigned.push(shift);
      }
    }

    return result;
  }
);
